export const templateItems = [
  {
    group: "Who's the next winner?",
    label: 'Jim',
    weight: 5,
    order: 0
  },
  {
    group: "Who's the next winner?",
    label: 'John',
    weight: 1,
    order: 1
  },
  {
    group: "Who's the next winner?",
    label: 'Will',
    weight: 5,
    order: 2
  },
  {
    group: "Who's the next winner?",
    label: 'Mark',
    weight: 1,
    order: 3
  },
  {
    group: "Who's the next winner?",
    label: 'Emily',
    weight: 4,
    order: 4
  },
  {
    group: "Who's the next winner?",
    label: 'Sarah',
    weight: 3,
    order: 5
  },
  {
    group: "Who's the next winner?",
    label: 'David',
    weight: 2,
    order: 6
  },
  {
    group: "Who's the next winner?",
    label: 'Michael',
    weight: 1,
    order: 7
  },
  {
    group: "Who's the next winner?",
    label: 'Jessica',
    weight: 3,
    order: 8
  },

  {
    group: 'Motorcycle Club Raffle',
    label: 'Ducati Panigale V4',
    weight: 7,
    order: 9
  },
  {
    group: 'Motorcycle Club Raffle',
    label: 'BMW S1000RR',
    weight: 4,
    order: 10
  },
  {
    group: 'Motorcycle Club Raffle',
    label: 'Yamaha YZF-R1',
    weight: 6,
    order: 11
  },
  {
    group: 'Motorcycle Club Raffle',
    label: 'Kawasaki Ninja H2',
    weight: 8,
    order: 12
  },
  {
    group: 'Motorcycle Club Raffle',
    label: 'Yamaha MT-10',
    weight: 10,
    order: 13
  },
  {
    group: 'Motorcycle Club Raffle',
    label: 'Suzuki GSX-R1000',
    weight: 3,
    order: 14
  },
  {
    group: 'Motorcycle Club Raffle',
    label: 'Honda Gold Wing',
    weight: 2,
    order: 15
  },
  {
    group: 'Motorcycle Club Raffle',
    label: 'Triumph Rocket 3',
    weight: 2,
    order: 16
  },
  {
    group: 'Motorcycle Club Raffle',
    label: 'Aprilia RSV4',
    weight: 10,
    order: 17
  },
  {
    group: 'Motorcycle Club Raffle',
    label: 'Suzuki Hayabusa',
    weight: 3,
    order: 19
  },
  {
    group: 'Motorcycle Club Raffle',
    label: 'Indian Challenger',
    weight: 4,
    order: 20
  },
  {
    group: 'Motorcycle Club Raffle',
    label: 'Kawasaki Z H2',
    weight: 9,
    order: 23
  },

  {
    group: '晚餐吃什麼?',
    label: '火鍋',
    weight: 5,
    order: 24
  },
  {
    group: '晚餐吃什麼?',
    label: '牛肉麵',
    weight: 4,
    order: 25
  },
  {
    group: '晚餐吃什麼?',
    label: '牛排館',
    weight: 3,
    order: 26
  },
  {
    group: '晚餐吃什麼?',
    label: '拉麵',
    weight: 2,
    order: 27
  },
  {
    group: '晚餐吃什麼?',
    label: '便當店',
    weight: 1,
    order: 28
  },
  {
    group: '晚餐吃什麼?',
    label: '自助餐',
    weight: 1,
    order: 29
  },
  {
    group: '晚餐吃什麼?',
    label: '夜市',
    weight: 3,
    order: 30
  },
  {
    group: '晚餐吃什麼?',
    label: '速食店',
    weight: 10,
    order: 31
  },
  {
    group: '晚餐吃什麼?',
    label: '中餐館',
    weight: 3,
    order: 32
  }
];
